/* eslint-disable no-unused-vars */
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { login } from 'store/auth/auth';
import 'assets/login.css';
import { getIsLocalHost } from 'utils';
import { Loader } from 'components';

const redirectToOldPlatformLoginUrl1 = (pathWithQuery) => {
  const currentUrl = new URL(window.location.href);
  let domainParts = currentUrl.hostname.split('.');
  if (!isNaN(domainParts[0])) {
    domainParts.shift();
  }
  const newUrl = `https://${domainParts.join('.')}${pathWithQuery}`;
  return newUrl;
};
const redirectToOldPlatformLoginUrl = (pathWithQuery) => {
  const currentUrl = new URL(window.location.href);
  console.log({ currentUrl });
  let domainParts = currentUrl.hostname.split('.');
  console.log({ domainParts }, !isNaN(domainParts[0]));
  if (!isNaN(domainParts[0])) {
    domainParts.shift();
  }
  const newUrl = `https://${domainParts.join('.')}${pathWithQuery}`;
  console.log({ newUrl });
  return newUrl;
};

const Login = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();
  const authError = useSelector((state) => state.auth.authError);
  const isSSoLoading = useSelector((state) => state.auth.isSsoLoading);
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  const onSubmit = (data) => {
    dispatch(login(data));
  };

  const isLocalHost = getIsLocalHost();
  // console.log({ isLocalHost });

  // if (!isSSoLoading && !isLoggedIn && !isLocalHost) {
  //   setTimeout(() => {
  //     const newUrl = redirectToOldPlatformLoginUrl(`/login2.aspx`);
  //     console.log(newUrl);
  //     window.location.href = newUrl;
  //     return null;
  //   }, 500);
  // }

  // if (!isSSoLoading && !isLocalHost) {
  //   setTimeout(() => {
  //     const newUrl = redirectToOldPlatformLoginUrl(`/login2.aspx`);
  //     console.log(newUrl);
  //     window.location.href = newUrl;
  //     return null;
  //   }, 500);
  // }
  if (!isLocalHost) {
    return <Loader.Global delay={0} />;
  }

  if (isLocalHost) {
    return (
      <div
        className='flex-div'
        //style={{ display: !isLocalHost && 'none' }}
      >
        <form onSubmit={handleSubmit(onSubmit)} id='login'>
          <h2 style={{ textAlign: 'center', paddingBottom: '15px' }}>{t('login.admin_title')}</h2>
          {authError && <div style={{ color: '#e93030', paddingBottom: '15px' }}>{authError}</div>}
          <input
            {...register('username', { required: true })}
            aria-invalid={errors.firstName ? 'true' : 'false'}
          />
          {errors.username?.type === 'required' && <p role='alert'>Username is required</p>}

          <input
            {...register('password', { required: 'Password is required' })}
            aria-invalid={errors.password ? 'true' : 'false'}
          />
          {errors.password && <p role='alert'>{errors.password?.message}</p>}

          <input type='submit' />
        </form>
      </div>
    );
  }
};

export default Login;
